import { ReactComponent as Link3DViewIcon } from 'assets/wg-3d-view.svg';
import React from 'react';

import styles from './Link3DView.module.scss';

interface Props {
  to: string;
}

const Link3DView: React.FC<Props> = ({ to }) => {
  return (
    <a href={to} target="_blank" rel="noreferrer noopener" className={styles.link3DView}>
      <div className={styles.linkContainer}>
        <Link3DViewIcon />
      </div>
    </a>
  );
};

export default Link3DView;
